<template>
  <div>
    <i-modal :value="system" @on-cancel="cancel" @on-ok="ok" class-name="vertical-center-modal">
      <div slot="header" style="text-align:center">
        <h2>新增一级指标</h2>
      </div>
      <div style="text-align:center">
        <i-row style="margin:15px 0 30px 0">
          <i-col span="6">
            <span class="title" style="float:right;">名称：</span>
          </i-col>
          <i-col span="18">
            <i-input style="width: 200px" v-model="addSystemName"></i-input>
          </i-col>
        </i-row>
      </div>
      <div style="text-align:center">
        <i-row style="margin:15px 0 30px 0">
          <i-col span="6">
            <span class="title" style="float:right;">是否为综合指标：</span>
          </i-col>
          <i-col span="18">
            <i-Radio-group v-model="is_synthesis">
              <i-radio label="是"></i-radio>
              <i-radio label="否"></i-radio>
            </i-Radio-group>
          </i-col>
        </i-row>
      </div>
      <div slot="footer" style="text-align:center">
        <i-button type="primary" size="large" style="width:200px" @click="ok">确认</i-button>
      </div>
    </i-modal>
    <div v-if="showLoading" class="demo-spin-col" span="8">
      <i-spin fix>
        <i-icon type="ios-loading" size="18" class="demo-spin-icon-load"></i-icon>
        <div>Loading</div>
      </i-spin>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      force: "no",
      showLoading: false,
      addSystemName: "",
      newbanben: "国内版",
      is_synthesis: "否",
    }
  },
  props: {
    system: {
      type: Boolean,
      default: false,
    },
    systemName: {},
    systemTypeName: {},
    categorytype: {},
  },
  methods: {
    cancel() {
      this.addSystemName = ""
      this.$emit("cancelAddCategory")
    },
    confirmAdd() {
      this.addSystemName = ""
      this.$emit("confirmAdd")
    },
    close() {
      this.$emit("close")
    },
    async ok() {
      const self = this
      console.log("添加的结果为:", this.addSystemName, this.newbanben, this.is_synthesis)
      let xdata = {
        name: this.addSystemName,
        category: this.categorytype,
        is_synthesis: this.is_synthesis == "是" ? true : false,
      }
      console.log("要传的数据为：", xdata)
      const res = await this.axios({
        method: "post",
        url: self.$store.state.baseurl + "/api/bi/indicator_create",
        params: xdata,
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        console.log("添加指标数据数据成功")
        this.confirmAdd()
        this.showLoading = false
      } else {
        this.$Message.error("操作失败，错误原因：" + res.data.error_message)
        this.showLoading = false
      }
    },
  },
}
</script>
<style scoped></style>
